import urlJoin from 'url-join';
import { logError } from '@tools/LogsHandler';
import { URLScheme } from '@cfg/UrlScheme.ts';

// const __USAR_CURRENT_URL = true;

const getPathFromUrlName = (urlName: string): string => {
  const keys = urlName.split(':');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let currentScheme: any | string = URLScheme; // Comienza en el nivel superior de __URL_SCHEME
  for (const key of keys) {
    // Navegar a través de cada nivel de __URL_SCHEME basado en `key`
    if (currentScheme[key]) {
      currentScheme = currentScheme[key];
    } else {
      // Si la clave no existe en el esquema actual, terminar el bucle y devolver un mensaje de error o cadena vacía
      logError('La ruta especificada no existe en el esquema de URL. urlName: ', urlName);
      return ''; // O podrías devolver undefined o null dependiendo de cómo quieras manejar este caso
    }
  }

  // Verificar que el resultado final sea una cadena (URL)
  if (typeof currentScheme === 'string') {
    return currentScheme;
  } else {
    logError('La ruta encontrada no es una URL válida.');
    return ''; // O manejar de otra manera si es necesario
  }
};

export const getHost = (): string => {
  const explicit = import.meta.env.VITE_API_URL;
  if (explicit) {
    return String(explicit).replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }

  return '';
};

const getFormUrl = (url_name: string, use_current_url: boolean = false) => {
  if (use_current_url) {
    return urlJoin(window.location.href, 'api/');
  }

  const host = getHost();
  const path = getPathFromUrlName(url_name);

  if (!host) {
    return path;
  }

  return new URL(path, host).toString();
};

export { getFormUrl };
